import template from './sw-cms-el-preview-product-slider.html.twig';
import './sw-cms-el-preview-product-slider.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
